import * as React from 'react'
import { useAccount, useNetwork, useWalletClient } from 'wagmi'
import { providers } from 'ethers'
import { getChainId } from 'config/constants/exchange'

export function walletClientToSigner(walletClient) {
    const { account, chain, transport } = walletClient
    const network = {
        chainId: chain.id,
        name: chain.name,
        ensAddress: chain.contracts?.ensRegistry?.address,
    }
    const provider = new providers.Web3Provider(transport, network)
    const signer = provider.getSigner(account.address)
    return signer
}

/** Hook to convert a viem Wallet Client to an ethers.js Signer. */
export function useEthersSigner() {
    const { chain } = useNetwork()
    const { address } = useAccount();

    const { data: walletClient } = useWalletClient({ chainId: getChainId(chain) })
    return React.useMemo(
        () => (walletClient ? walletClientToSigner(walletClient) : undefined),
        [walletClient , address, chain],
    )
}